import { SET_COMMENTS } from '../actions/types';

export default function comments(state = {}, action) {
	if (!action.error && action.payload !== undefined) {
		switch (action.type) {
			case SET_COMMENTS:
				return action.payload;

			// no default
		}
	}

	return state;
}
